import { render } from "./sitemap-welcome.vue?vue&type=template&id=7fed794a"
import script from "./sitemap-welcome.js?vue&type=script&lang=js"
export * from "./sitemap-welcome.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__